import React from "react";
import {
  formatMoney,
  formatPoint,
  getProfileBalance,
  WALLET_VIEWS,
} from "./financeWallet.helpers";

const WalletDepositIcon = () => (
  <svg viewBox="0 0 28 28" aria-hidden="true">
    <path
      d="M5.2 9.2h15.7c1.8 0 3.2 1.4 3.2 3.2v7.9c0 1.8-1.4 3.2-3.2 3.2H5.2c-1.8 0-3.2-1.4-3.2-3.2v-7.9c0-1.8 1.4-3.2 3.2-3.2Z"
      fill="currentColor"
      opacity=".2"
    />
    <path
      d="M6.5 8.8V7.1c0-1.4 1.1-2.5 2.5-2.5h10c1.4 0 2.5 1.1 2.5 2.5v2.1"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <path
      d="M4.9 9.2h16.4c1.8 0 3.2 1.4 3.2 3.2v8c0 1.8-1.4 3.2-3.2 3.2H4.9c-1.8 0-3.2-1.4-3.2-3.2v-8c0-1.8 1.4-3.2 3.2-3.2Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M18.2 14v5.7m0 0-2.3-2.3m2.3 2.3 2.3-2.3"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    />
    <path d="M24.5 14.2h-4.1a2.1 2.1 0 0 0 0 4.2h4.1" fill="currentColor" opacity=".32" />
  </svg>
);

const WalletWithdrawIcon = () => (
  <svg viewBox="0 0 28 28" aria-hidden="true">
    <path
      d="M5.2 9.2h15.7c1.8 0 3.2 1.4 3.2 3.2v7.9c0 1.8-1.4 3.2-3.2 3.2H5.2c-1.8 0-3.2-1.4-3.2-3.2v-7.9c0-1.8 1.4-3.2 3.2-3.2Z"
      fill="currentColor"
      opacity=".2"
    />
    <path
      d="M6.5 8.8V7.1c0-1.4 1.1-2.5 2.5-2.5h10c1.4 0 2.5 1.1 2.5 2.5v2.1"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <path
      d="M4.9 9.2h16.4c1.8 0 3.2 1.4 3.2 3.2v8c0 1.8-1.4 3.2-3.2 3.2H4.9c-1.8 0-3.2-1.4-3.2-3.2v-8c0-1.8 1.4-3.2 3.2-3.2Z"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M18.2 20v-5.7m0 0-2.3 2.3m2.3-2.3 2.3 2.3"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2.2"
    />
    <path d="M24.5 14.2h-4.1a2.1 2.1 0 0 0 0 4.2h4.1" fill="currentColor" opacity=".32" />
  </svg>
);

const PointIcon = () => (
  <svg viewBox="0 0 28 28" aria-hidden="true">
    <path
      d="M8.1 8.5c1.3-1.8 3.4-3 5.9-3 4.2 0 7.6 3.4 7.6 7.6 0 1.2-.3 2.3-.8 3.3"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeWidth="2"
    />
    <path
      d="M19.7 8.2h2.1V6.1M19.9 19.5c-1.4 1.9-3.6 3-6 3-4.2 0-7.6-3.4-7.6-7.6 0-1.1.2-2.1.6-3.1"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path
      d="M8.3 19.8H6.2v2.1"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path d="M11.2 14h5.6m-2.8-2.8v5.6" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2.2" />
  </svg>
);

const CompIcon = () => (
  <svg viewBox="0 0 28 28" aria-hidden="true">
    <path
      d="M5.2 8.3h17.6v4.1a2.1 2.1 0 0 0 0 4.2v4.1H5.2v-4.1a2.1 2.1 0 0 0 0-4.2V8.3Z"
      fill="none"
      stroke="currentColor"
      strokeLinejoin="round"
      strokeWidth="2"
    />
    <path d="M11.2 11.4h5.7M11.2 16.6h3.7" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2" />
    <path d="M18.8 13.8h.1M18.8 18.1h.1" fill="none" stroke="currentColor" strokeLinecap="round" strokeWidth="2.7" />
  </svg>
);

const walletActions = [
  {
    key: WALLET_VIEWS.DEPOSIT,
    label: "입금",
    caption: "계좌 문의와 입금 신청",
    icon: WalletDepositIcon,
    balanceLabel: "보유금",
    balanceType: "money",
    unit: "원",
  },
  {
    key: WALLET_VIEWS.WITHDRAW,
    label: "출금",
    caption: "보유금 출금 신청",
    icon: WalletWithdrawIcon,
    balanceLabel: "출금 가능",
    balanceType: "money",
    unit: "원",
  },
  {
    key: WALLET_VIEWS.POINT,
    label: "포인트",
    caption: "포인트 전환 신청",
    icon: PointIcon,
    balanceLabel: "보유 포인트",
    balanceType: "point",
    point: true,
  },
  {
    key: WALLET_VIEWS.COMP,
    label: "콤프",
    caption: "콤프 전환 신청",
    icon: CompIcon,
    balanceLabel: "보유 콤프",
    balanceType: "comp",
    point: true,
  },
];

const WalletHome = ({ profile, onSelect }) => (
  <div className="cashier-home">
    <div className="cashier-action-grid">
      {walletActions.map((action) => {
        const balance = getProfileBalance(profile, action.balanceType);
        const formatted = action.point ? formatPoint(balance) : `${formatMoney(balance)} ${action.unit}`;
        const Icon = action.icon;

        return (
          <button
            key={action.key}
            type="button"
            className="cashier-action-card"
            onClick={() => onSelect(action.key)}
          >
            <span className="cashier-action-icon">
              <Icon />
            </span>
            <span className="cashier-action-copy">
              <strong>{action.label}</strong>
              <small>{action.caption}</small>
            </span>
            <span className="cashier-action-balance">
              <em>{action.balanceLabel}</em>
              <b>{formatted}</b>
            </span>
          </button>
        );
      })}
    </div>
  </div>
);

export default WalletHome;
